import linkifyText from '@adsk/bim360-matrix-react-helpers/es/linkifyText';
import escapeHtml from '@adsk/bim360-matrix-react-helpers/es/escapeHtml';

export const htmlEntities = str =>
  String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

export const getScrollableParent = childNode => {
  if (!childNode) {
    return null;
  }

  if (childNode.scrollHeight > childNode.clientHeight) {
    return childNode;
  } else {
    return getScrollableParent(childNode.parentNode);
  }
};

export const sanitizeAndLinkifyHtml = html => linkifyText(escapeHtml(html));
